import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import ClubMainPage from "../Club/ClubMainPage";
import "./ContractFarming.css";
import SocialMarketNavbar from "../SocialMarketNavbar/SocialMarketNavbar";

export default function ContractFarming() {
  const userTypes = ["AssetDeveloper"];

  return (
    <>
      <SocialMarketNavbar />
      <UpdatesBanner
        className="socialMarketplace text-white"
        bannerText="Buyers looking for Contract Farming"
      />

      <div className="subSectionWrapper">
        <ClubMainPage type={userTypes} />
      </div>
    </>
  );
}
